import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../../hooks/useSiteSettings';

export const GlobalSEO = () => {
  const { getSetting, loading } = useSiteSettings();
  const location = useLocation();

  // Determine page name from pathname
  const getPageName = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path.startsWith('/shop')) return 'shop';
    if (path.startsWith('/about')) return 'about';
    if (path.startsWith('/categories')) return 'categories';
    return 'home';
  };

  const pageName = getPageName();
  const siteName = getSetting('site_name', 'NaturalCare');
  const siteNameFull = getSetting('site_name_full', 'NaturalCare - Premium Natural Cosmetics');
  const faviconUrl = getSetting('favicon_url', '/favicon.ico');
  
  const seoTitle = getSetting(`seo_${pageName}_title`) || siteNameFull;
  const seoDescription = getSetting(`seo_${pageName}_description`) || getSetting('seo_home_description', 'Premium natural cosmetics and wellness products');
  const seoKeywords = getSetting(`seo_${pageName}_keywords`) || getSetting('seo_home_keywords', 'natural cosmetics, wellness');
  const seoImage = getSetting('seo_og_image', 'https://images.unsplash.com/photo-1643379855889-850035817d24?w=1200');

  // Force update when settings change
  useEffect(() => {
    if (!loading && seoTitle) {
      document.title = seoTitle;
    }
  }, [seoTitle, loading]);

  if (loading) return null;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <link rel="icon" type="image/x-icon" href={faviconUrl} />
      <link rel="shortcut icon" type="image/x-icon" href={faviconUrl} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content={siteName} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  );
};